// extracted by mini-css-extract-plugin
module.exports = {"no_results":"NoResults_no_results__1LY50"};